<template>
  <div class="col-12" style="max-width: 700px; margin: 0 auto;">
    <div class="my-4" >
      <h2 class="mb-4">
         <small>{{ data.source.name }} </small>
      </h2>
      <div
        v-if="data.source.format === 'html'"
        class="email-preview-content shadow"
      >
        <div v-if="isShadowDOMSupported" ref="shadowPreview" />
        <div v-else v-html="data.source.text" />
      </div>
      <div
        v-else
        class="border p-4"
      >
        <pre><code class="language-xml" v-html="sourceText"></code></pre>
      </div>
    </div>
  </div>
</template>

<script>
import Date from '@/directives/date'
import Prism from 'prismjs'
import 'prismjs/themes/prism.min.css'

export default {

  directives: {
    Date,
  },

  props: {
    data: {
      type: Object,
      default: null,
    },
  },

  mounted() {
    this.isShadowDOMSupported = !!document.head.attachShadow
    console.log('hello?????')

    setTimeout(() => {
      if (this.isShadowDOMSupported && this.data.source.format === 'html') {
        const shadowRoot =
          this.$refs.shadowPreview.shadowRoot ||
          this.$refs.shadowPreview.attachShadow({ mode: 'open' })
        shadowRoot.innerHTML = this.data.source.text
      }
    }, 500)
  },

  computed: {
    sourceText() {
      const response = Prism.highlight(
        this.data.source.text,
        Prism.languages.xml,
        'xml'
      )

      console.log(response)
      return response
    },
  },

}
</script>
